<template>
  <section id="cta" class="container-fluid bg-secondary text-white p-0 anchorFix">
    <div class="cta-bar bg-secondary text-white pt-4 pb-4 pb-lg-3">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-3 text-lg-center mb-3 mb-lg-0">
            <div class="cta-text float-right d-none d-lg-block">
              SOFORT ZUM<br>
              NEUEN AUTO:
            </div>
            <div class="cta-text text-md-center d-block d-lg-none">
              SOFORT ZUM NEUEN AUTO:
            </div>
          </div>
          <div class="col-12 col-md-5 offset-md-1 offset-lg-0 col-lg-3 text-lg-center mb-0">
            <div class="form-group">
              <select class="form-control" id="brandSelect" v-model="selectedBrand" v-on:change="loadVehicles()">
                <option value="">Marke</option>
                <option v-for="brand in brands" :key="brand.id" v-bind:value="brand">
                  {{ brand.title }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-12 col-md-5 col-lg-3 text-lg-center mb-3 mb-0">
            <div class="form-group">
              <select class="form-control" id="modelSelect" v-model="selectedModel" :disabled="Object.keys(selectedBrand).length === 0">
                <option value="">Modell</option>
                <option v-for="model in models" :key="model.id" v-bind:value="model">
                  {{ model.title }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-12 col-lg-3 text-center px-lg-3 text-center">
            <a :href="getUrl" class="brand-model-cta-button btn btn-primary btn-lg px-5 mobile-block mb-md-2">
              Auto finden
            </a>

            <a :href="catalogUrl" class="catalog-link d-block d-lg-inline mt-2">
              oder alle Fahrzeuge anzeigen
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    catalogUrl: {
      type: String,
      required: true
    }
  },
  data(){
    return {
      brands: Array,
      models: Array,
      selectedBrand: '',
      selectedModel: '',
      catalogSearchUrl: ''
    }
  },
  methods: {
    loadBrands(){
      this.catalogSearchUrl = ''
      axios.get("/api/brand-model-selection/get-active")
          .then(result => {
            this.brands = result.data
          })
          .catch(error => {
            console.warn(error.message)
          });
    },
    loadVehicles(){
      axios.get("/api/brands/" + this.selectedBrand.id + '/models')
          .then(result => {
            this.catalogSearchUrl = this.catalogUrl + '?brand=' + this.selectedBrand.id
            this.models = result.data
            this.selectedModel = '';
          })
          .catch(error => {
            console.warn(error.message)
          });
    }
  },
  watch: {},
  computed: {
    getUrl(){
      if(this.selectedBrand !== '' && this.selectedModel === ''){
        return this.catalogUrl + '?brand=' + this.selectedBrand.id
      }
      if(this.selectedBrand !== '' && this.selectedModel !== ''){
        return this.catalogUrl + '?brand=' + this.selectedBrand.id + '&model=' + this.selectedModel.id
      }

      return this.catalogUrl;
    }
  },
  mounted(){
    this.catalogSearchUrl = this.catalogUrl
  },
  created(){
    this.loadBrands()
  }
}
</script>

<style scoped>
.anchorFix {
  border-top: 95px solid transparent;
  margin: -95px 0 0;
  -webkit-background-clip: padding-box;
  -moz-background-clip: padding;
  background-clip: padding-box;
}

.brand-model-cta-button {
  height: 47px;
}
#modelSelect, #brandSelect {
  border-radius: 3px;
  padding: 0.75rem;
}

.cta-text {
  font-size: 12px;
  font-weight: bold;
  color: #fff;
}

.catalog-link {
  font-size: 14px;
  text-align: center;
  color: #fff;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .mobile-block {
    width: 100%;
    display:block;
  }
}

@media (min-width: 768px) {
  .cta-text {
    font-size: 16px;
  }
}

@media (min-width: 992px) {
  .cta-text {
    width: 132px;
    text-align: left;
    font-weight: bold;
  }
}
</style>
